import React from 'react'
import useIconAccessor from 'components/lesson-type-category/icons'
import { Avatar, Box, Typography } from '@material-ui/core'
import { formatCurrency } from 'pages/schedule/utils'
import propTypes from 'prop-types'

const PaymentLink = ({
  timePeriod,
  title,
  student,
  price,
  classes,
  category,
}) => {
  const accessor = useIconAccessor()

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      className={classes.componentSpacing}
    >
      <Avatar variant="circular" className={classes.iconWrapper}>
        {accessor[category].icon}
      </Avatar>
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <Typography variant="h6" className={classes.timePeriodText}>
          {timePeriod}
        </Typography>
        <Typography
          variant="body1"
          className={classes.bodyText}
        >{`${title} with ${student?.firstName ||
          'Student'} ${student?.lastName || ''}`}</Typography>
        <Typography variant="body1" className={classes.bodyText}>
          {formatCurrency(price)}
        </Typography>
      </Box>
    </Box>
  )
}

PaymentLink.propTypes = {
  timePeriod: propTypes.string,
  title: propTypes.string,
  student: propTypes.object,
  price: propTypes.number,
  classes: propTypes.object,
  category: propTypes.string,
}

export default PaymentLink
